export default __webpack_public_path__ + "static/media/logo-app.ebadc8c8.png";